/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAppConfigSemaphore} from '../api'

 export const useQueryGetAppConfigSemaphore = createReactQueryHook('getAppConfigSemaphore', getAppConfigSemaphore)
